var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 154,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stress_svg__clip0_632_7191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.888 98.005s-42.114 99.331 36.711 91.033c7.084-22.126.255-56.672.255-56.672v-25.201l-36.969-9.16h.003z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.608 98.005s41.816 99.331-37.009 91.033c-7.084-22.126.04-56.672.04-56.672v-25.201l36.969-9.16z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.038 128.306l6.676-1.892s-.877-21.527 9.291-4.497c33.138 15.491 31.451-49.576 25.02-66.813-6.427-17.234-23.374-19.262-23.374-19.262H82.484s-18.45 2.028-24.881 19.262c-6.427 17.234-4.385 89.928 26.527 66.813 10.168-17.033 9.29 4.497 9.29 4.497l12.618 1.892z",
    fill: "#008AE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.857 57.362c13.917 0 25.198-11.744 25.198-26.232 0-14.487-11.281-26.231-25.198-26.231-13.916 0-25.198 11.744-25.198 26.232 0 14.487 11.282 26.231 25.198 26.231z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.679 47.797c1.355-4.78-.456-9.549-4.045-10.651-3.59-1.103-7.597 1.878-8.952 6.658-1.355 4.78.456 9.548 4.045 10.651 3.589 1.102 7.597-1.879 8.952-6.658zM84.402 53.99c3.59-1.102 5.4-5.87 4.046-10.65-1.355-4.78-5.363-7.761-8.952-6.659-3.59 1.103-5.4 5.871-4.046 10.651 1.355 4.78 5.363 7.761 8.952 6.659z",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.535 46.77c-1.582 14.325-9.752 23.595-18.202 23.595-7.877 0-16.766-9.267-18.201-23.595 0-13.031.697-27.926 18.201-23.594 9.779 2.42 18.202 10.563 18.202 23.594z",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.647 37.542s6.01 1.575 11.12-3.233c1.684 3.383 2.297 10.498.252 17.519l4.616 2.916M97.675 60.236s4.061-3.554 8.363 0",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7 23.665s6.813 13.583 26.063 15.03c4.292-10.701-.825-16.588-.825-16.588l-7.485-7.682-13.368-3.451-11.976 6.124-2.248 12.024.022 8.437s6.963-5.08 9.817-13.894zM101.264 134.375s4.006-59.49-21.616-46.093c.583 9.01 6.99 34.721 0 36.425 3.181 9.778 8.665 11.246 8.665 11.246l12.954-1.578h-.003zM104.654 134.375s-3.371-26.134 2.051-41.324c2.978-8.346 13.255-10.478 17.806-5.712 0 0-4.467 36.477 1.758 37.368-3.181 9.778-8.665 11.246-8.665 11.246l-12.953-1.578h.003zM88.31 161.828l-8.665 42.601s-19.11 5.028-25.995-6.805c.79-19.229 4.769-48.221 4.769-48.221l29.888 12.425h.003zM113.56 161.828l8.665 42.601s19.11 5.028 25.994-6.805c-.79-19.229-4.768-48.221-4.768-48.221l-29.888 12.425h-.003z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.483 188.704s13.446-53.836 13.599-73.082M119.636 188.704s-11.466-53.836-11.618-73.082",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.31 42.934s5.708-5.174 7.771.301M113.044 43.083s-5.434-5.24-7.772.301",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.454 42.283c0 1.192-.694 1.623-1.55 1.623-.855 0-1.55-.431-1.55-1.623 0-1.193.695-1.442 1.55-1.442.856 0 1.55.25 1.55 1.442zM110.15 42.403c0 1.192-.694 1.652-1.55 1.652-.856 0-1.55-.46-1.55-1.652s1.248-1.494 2.104-1.494c.856 0 .993.302.993 1.494h.003z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.314 43.32c-1.108-.1-2.22-.234-3.33-.298-1.002-.059-1.986.07-2.786.754-.264.227-.224.697 0 .93.262.272.629.227.894 0 .572-.489 1.469-.405 2.156-.35 1.021.085 2.042.188 3.066.279.34.032.632-.324.632-.658 0-.382-.29-.625-.632-.657zM108.191 44.83a17.744 17.744 0 015.351-.1c.339.045.632-.334.632-.658 0-.393-.293-.613-.632-.658a18.806 18.806 0 00-5.687.146c-.336.058-.526.492-.442.81.097.372.439.518.778.46z",
    fill: "#008AE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.657 41.978s-3.006-2.2-5.59 3.364l5.59-3.364z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.657 41.978s-3.006-2.2-5.59 3.364",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.181 49.612s3.423-5.43.681-7.634l-.681 7.634z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.181 49.612s3.423-5.43.681-7.634",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.35 41.981s3.006-2.2 5.59 3.363l-5.59-3.363z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.35 41.981s3.006-2.2 5.59 3.363",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.828 49.618s-3.424-5.43-.682-7.633l.682 7.633z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.828 49.618s-3.424-5.43-.682-7.633",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.66 105.726l48.867 21.006-2.35 18.549s-59.475-.716-64.003-33.068c3.794-14.253 17.485-6.487 17.485-6.487z",
    fill: "#008AE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.737 101.32L70.98 120.893l4.68 20.027s67.403-4.967 71.648-31.811c-11.659-12.425-15.574-7.789-15.574-7.789h.003z",
    fill: "#008AE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.797 122.342s-19.764 2.971-20.274 12.409c-3.16 4.455-.423 6.172-.423 6.172s-1.756 4.358 2.054 6.377c.491 4.186 4.519 3.382 4.519 3.382l.501-6.911s3.831-1.254 6.39-1.276c7.36-.068 11.715-3.289 11.715-3.289l11.03-3.25",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.797 122.342s-19.764 2.971-20.274 12.409c-3.16 4.455-.423 6.172-.423 6.172s-1.756 4.358 2.054 6.377c.491 4.186 4.519 3.382 4.519 3.382l.501-6.911s3.831-1.254 6.39-1.276c7.36-.068 11.715-3.289 11.715-3.289l11.03-3.25",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.64 117.673l6.02 23.247 21.002-2.884.89-5.728-5.91-7.864-22.001-6.771z",
    fill: "#008AE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.523 134.748s2.956-3.72 7.815-4.322l-7.816 4.322z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.523 134.748s2.956-3.72 7.815-4.322",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.338 134.748s-6.894 2.038-8.238 6.172l8.238-6.172z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.338 134.748s-6.894 2.038-8.238 6.172",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.684 139.125s-7.416 1.497-6.53 8.171l6.53-8.171z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.684 139.125s-7.416 1.497-6.53 8.171",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.529 126.732s24.442 3.859 24.949 13.297c3.159 4.455.423 6.172.423 6.172s1.756 4.358-2.054 6.377c-.492 4.186-4.519 3.382-4.519 3.382l-.501-6.911s-3.832-1.254-6.39-1.276c-7.361-.068-11.715-3.289-11.715-3.289l-11.031-3.25",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.529 126.732s24.442 3.859 24.949 13.297c3.159 4.455.423 6.172.423 6.172s1.756 4.358-2.054 6.377c-.492 4.186-4.519 3.382-4.519 3.382l-.501-6.911s-3.832-1.254-6.39-1.276c-7.361-.068-11.715-3.289-11.715-3.289l-11.031-3.25",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.479 140.029s-2.956-3.72-7.815-4.322l7.815 4.322z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.479 140.029s-2.956-3.72-7.815-4.322",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.664 140.029s6.894 2.038 8.239 6.172l-8.239-6.172z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.664 140.029s6.894 2.038 8.239 6.172",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.319 144.406s7.417 1.497 6.53 8.172l-6.53-8.172z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.319 144.406s7.417 1.497 6.53 8.172",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.181 145.278l3.72-23.526h-11.958l-6.925 9.995 2.39 11.366 12.773 2.165z",
    fill: "#008AE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.259 166.976l2.916-23.208M145.929 169.838l-2.101-20.789",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.488 112.981l32.78 11.726-3.087 20.571",
    stroke: "#008AE9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.088 118.8s5.36 17.743 34.993 22.901c6.533-11.693-4.439-17.253-4.439-17.253l-16.396-9.591-4.805-1.251-9.353 5.194z",
    fill: "#008AE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4 124.444s6.666 10.997 24.625 15.585M81.948 107.998l-6.598-2.907M122.584 104.268l7.236-2.329M79.647 88.282l-2.988-15.04M124.51 87.34l1.018-15.65",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.812 35.842s14.321 6.27 16.241 22.816c5.671-13.32-1.734-27.527-1.734-27.527l-11.276-2.904M102.67 18.06c5.566 0 10.078-4.043 10.078-9.03 0-4.987-4.512-9.03-10.078-9.03S92.592 4.043 92.592 9.03c0 4.987 4.512 9.03 10.078 9.03z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.906 6.785s9.294-4.614 18.603.398M124.715 37.52s-.517-3.82-3.648-7.297",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.638 44.27a14.042 14.042 0 00-.093 5.591c.065.35.467.548.778.46.352-.1.504-.46.442-.81a12.331 12.331 0 01.094-4.892c.077-.347-.103-.713-.442-.81a.637.637 0 00-.779.46zM113.047 44.243c2.434 7.183 2.58 15.108.492 22.405a35.994 35.994 0 01-2.3 5.965c-.371.752.719 1.416 1.089.664 3.47-7.044 4.666-15.173 3.489-22.985a36.925 36.925 0 00-1.553-6.4c-.268-.793-1.488-.45-1.217.35z",
    fill: "#008AE9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "stress_svg__clip0_632_7191"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h167v154H0z"
  })))));
}
export default __webpack_public_path__ + "static/stress.e175a934.svg";
export { SvgStress as ReactComponent };